import { CSSProperties, FC, HTMLProps, useMemo } from 'react';
import cx from 'classnames';

import { shadeColor } from 'utils';

import styles from './Color.module.scss';

export type ColorProps = Pick<HTMLProps<HTMLDivElement>, 'className' | 'style'> & {
  color: string;
};

const getGradient = (color: string) =>
  `linear-gradient(215deg, ${shadeColor(color, 56)} 18%, ${shadeColor(color, 12)} 48%, ${shadeColor(
    color,
    7
  )} 59%, ${shadeColor(color, 0)} 100%)`;

const Color: FC<ColorProps> = ({ children, color, className, ...htmlProps }): JSX.Element => {
  const containerStyles: CSSProperties = useMemo(() => ({ backgroundColor: color }), [color]);
  const overlayStyles: CSSProperties = useMemo(() => ({ background: getGradient(color) }), [color]);

  return (
    <div className={cx(styles.container, className)} style={containerStyles} {...htmlProps}>
      <div className={styles.overlay} style={overlayStyles} />
      {children}
    </div>
  );
};

export default Color;
